import { AbstractCustomField } from '@/components/Fields/dataObjects/AbstractCustomField'
import { CustomFieldCustomFieldOptionInput, CustomFieldType } from '@/gql/graphql'

export class DateField extends AbstractCustomField {
  fieldType: CustomFieldType = CustomFieldType.Date

  optionsForGraphQL(): CustomFieldCustomFieldOptionInput[] {
    // Dates do not have options
    return []
  }
}
